module.exports = __webpack_public_path__ + "img/placeholder.8e8525b9.jpg";